<div class="flex flex-col gap-4 max-w-xl">
  @if (!enabled) {
    <p class="text-red-600 font-medium">Manual notification check is disabled in this environment.</p>
    <button pButton label="Back" (onClick)="goBack()"></button>
  } @else {
    <h2 class="text-xl font-semibold">Trigger check-for-notifications</h2>
    @if (allowCustomTime) {
      <p class="text-sm text-muted-color">Provide an optional ISO datetime to use as the current time for the run.</p>
      <div class="flex flex-col gap-2">
        <label class="text-sm font-medium" for="currentTime">Current time (ISO, optional)</label>
        <input id="currentTime" type="datetime-local" class="p-inputtext p-component" [(ngModel)]="currentTime">
      </div>
    } @else {
      <p class="text-sm text-muted-color">This will run immediately using the current time.</p>
    }
    <p class="text-sm text-orange-600">Note: this job can take 10+ minutes to finish processing in the background.</p>
    <div class="flex gap-3">
      <admin-submit-button
        [label]="'Run now'"
        [severity]="'primary'"
        [submitFunction]="trigger"
        [disabled]="loading()"/>
      <p-button label="Back" severity="secondary" (onClick)="goBack()"></p-button>
    </div>
  }
</div>
